// deps
import React, { memo } from "react";

// types
import { PLBillCtaAction, PLBillDisplayLineItem } from "@swiggy-private/cart-types";
import { PL_BILL_DISPLAY_ITEM_TEST_IDS } from "@swiggy-private/cart-test-ids";

// components
import BillPrimitives from "../pl-bill-primitives/BillPrimitives";

// styles
import { DisplayRow } from "./BillDisplayItem.style";

interface BillDisplayItemProps {
    item: PLBillDisplayLineItem;
    actionMap?: Record<PLBillCtaAction, VoidFunction>;
}

const BillDisplayItem = ({ item, actionMap }: BillDisplayItemProps) => (
    <DisplayRow data-testid={PL_BILL_DISPLAY_ITEM_TEST_IDS.CONTAINER}>
        {item?.details?.map((col, idx: number) => (
            <BillPrimitives key={idx} items={col.items} actionMap={actionMap} />
        ))}
    </DisplayRow>
);

export default memo(BillDisplayItem);
